import React from 'react';
import autoBind from 'react-autobind';
import Download from 'downloadjs';

import Spinner from './Common/Spinner.jsx';
import InlineMessage from './Common/InlineMessage.jsx';
import SlidingSessionNotification from './SlidingSessionNotification.jsx';

import PageHeading from './Congratulations/PageHeading.jsx';
import ReadyForFunding from './Congratulations/ReadyForFunding.jsx';
import ShellAccount from './Congratulations/ShellAccount.jsx';
import Footer from './Footer.jsx';
import FooterUtil from './../utils/FooterHelper';

import ContentService from '../services/ContentService'; 
import CongratulationsStore from '../stores/CongratulationsStore';
import {messageTypes, SpinnerSizes, UserTypes} from '../constants/ApplicationConstants';
import CongratulationsActions from '../actions/CongratulationsActions.js';
import DownloadConstants from '../constants/DownloadConstants.js';
import UrlService from '../services/UrlService';
import UserNotification from './Common/UserNotification.jsx';
import OmnitureTracking from './../utils/OmnitureTracking.js';
import AdviceFeeStore from '../stores/AdviceFeeStore.js';
import ApplicationConstants from '../constants/ApplicationConstants';

export default class Congratulations extends React.Component {
	constructor(props) {
        super(props);
        autoBind(this);
        this.showNotifiction = true;
        this.content = ContentService.getContent();
        this.state = this.getStateFromStore();
	}

    getStateFromStore(){
        return {
            heading: CongratulationsStore.getHeadingModel(),
            body: CongratulationsStore.getBodyModel(),
            isShellAccount: CongratulationsStore.getIsShellAccount(),
            isSingleAccount: CongratulationsStore.getIsSingleAccount(),
            productName: CongratulationsStore.getProductName(),
            userType: CongratulationsStore.getUserType(),
            productCode: CongratulationsStore.getProductCode(),
            downloadData: CongratulationsStore.getDownloadData(),
            downloadFormModel: CongratulationsStore.getDownloadFormModel(),
            downloadedForm: CongratulationsStore.getDownloadedForm(),
            downloadedFormFileName: CongratulationsStore.getDownloadedFormFileName(),
            showNotifiction: this.showNotifiction,
            adviserServiceFeeFlag: AdviceFeeStore.getAdviserServiceFeeFlag(),
            investorDetails:CongratulationsStore.getInvestorDetailsForRedirection(),
            asfCongratulationsPageSwitch:CongratulationsStore.getAsfCongratulationsPageKillSwitch()
        }
    }

    componentDidMount() {
        CongratulationsStore.addChangeListener(this._onChange);
        OmnitureTracking.getTrackingEnabled();
    }

    componentWillUnmount() {
        CongratulationsStore.removeChangeListener(this._onChange);
    }

    componentDidUpdate(prevProps, prevState) {
        if (!prevState.downloadedForm && this.state.downloadedForm){
            Download(this.state.downloadedForm, this.state.downloadedFormFileName, DownloadConstants.PdfContentType);
            setTimeout(function() {
                CongratulationsActions.clearDownload();
            }, 1000);
        }
    }

    _onChange() {
        this.setState(this.getStateFromStore());
    }

    exit() {
        window.open(UrlService.getLogOffUrl(), '_self');
    }

    downloadAll(){
        CongratulationsActions.downloadAll(this.state.downloadFormModel, this.state.productCode);
    }

    downloadFile(id){
        CongratulationsActions.downloadFile(this.state.downloadFormModel, this.state.productCode, id);
    }

    closeCongratulationsNotification() {
        this.showNotifiction = false;
        this.setState({showNotifiction: false});
    }

    render() {
		if (!this.content || !this.content.congratulations || !this.state.heading.accountNumber){
			return null;
		}

        const footerContent = FooterUtil.getContent(this.state.productCode, this.content.footer);
        var showAsfForm= window.NOA.userContext.isAdviser  && this.state.adviserServiceFeeFlag === ApplicationConstants.YesNoValues.YES;
        return (
			<div>
                <SlidingSessionNotification className="congratulationsSessionNotif" />
                <UserNotification id="formsNotification"
                    className="forms-top-sticky-user-notification"
                    message={this.content.congratulations.formsNotification}
                    onClickButton={this.closeCongratulationsNotification}
                    messageClassName="congratulations-notification"
                    buttonText="Continue"
                    showButton={true}
                    isHidden={!this.state.showNotifiction}
                    hideIcon={true}/>
				<div className="page-heading__container">
					<PageHeading isShellAccount={this.state.isShellAccount}
								isSingleAccount={this.state.isSingleAccount}
								data={this.state.heading}
								product={this.state.productName}
                                productCode={this.state.productCode}
								content={this.content.congratulations} />
				</div>
                
        <div className="spacing__container">
          {showAsfForm && this.state.asfCongratulationsPageSwitch.killSwitch ? (
            <div className="container">
              <div className="spacing__container"></div>
              <div>
                <h4>Adviser service fee</h4>
                <div>
                  To complete your adviser service fee details, please click on
                  the button below:
                </div>
                {this.renderAsfButtonLink()}
              </div>
            </div>
          ) : null}
        </div>

				<div className="spacing__container">
                    {this.renderCompleteAccountApplication()}   
					{this.renderBody()}
				</div>
                {this.renderDownloadAll()}
                
                {showAsfForm && !this.state.asfCongratulationsPageSwitch.killSwitch?
                <div  className="container">                 
                    <div className="spacing__container"></div> 
                    <div>
                        <h4>Adviser Service Fee</h4>    
                        {
                        this.state.investorDetails.killSwitch? 
                        <div>To set up an Adviser Service Fee on this account, please complete the { <a href={window.NOA.configuration.firstNetDccUrl+'&eOin='+ this.state.investorDetails.eOin +'&eAccountNumber=' + this.state.investorDetails.eAccountNumber}> Adviser Service Fee form</a>}.</div>
                        :<div>To add an Adviser Service Fee to the account, please fill out a standalone Adviser Service Fee (ASF) form under the Forms section in the { <a href={window.NOA.configuration.firstNetDccUrl}> Digital Communications Tool (DCT)</a>}. </div>                                                                               
                        }
                        </div>
                </div>
                :null
                } 
				{this.rednerNavigation()}
				<Footer content={footerContent} />
			</div>
		);
    }

    renderBody(){
		if (this.state.isShellAccount){
           return <ShellAccount data={this.state.body}
                                isSingleAccount={this.state.isSingleAccount}
                                productCode={this.state.productCode}
                                userType={this.state.userType}
                                downloadFileCallBack={this.downloadFile}
                                content={this.content.congratulations} />;
		}
		else {
			return <ReadyForFunding data={this.state.body}
									userType={this.state.userType}
									content={this.content.congratulations}
                                    downloadFileCallBack={this.downloadFile}
                                    productCode={this.state.productCode} />;
		}
    }

    renderDownloadAll(){
        if (!this.state.downloadData){
            return null;
        }
        return (<div className="container">
                    <button type="button"
                            className="btn btn-download"
                            id="congratulationsDonwloadAll"
                            disabled={this.state.downloadData.buttonDisabled}
                            onClick={this.downloadAll}>
                        Download all
                    </button>
                    <Spinner inline={true} hide={!this.state.downloadData.showSpinner} size={SpinnerSizes.One} />
                    <InlineMessage id="downloadErrorMessage"
                                   isHidden={!this.state.downloadData.error}
                                   type={messageTypes.error}
                                   message={this.content.congratulations.downloadError} />
                </div>);
    }

    rednerNavigation(){
        let content = this.content.congratulations;
        let navText = content.navigationPublic;
        let rightIcon = this.state.userType === UserTypes.PUBLIC? 'icon icon-cancel-circled' : 'icon icon-right-open-big';
        if (this.state.userType === UserTypes.ADVISER){
            navText = content.navigationFna;
        }
        else if (this.state.userType === UserTypes.INVESTOR){
            navText = content.navigationFni;
        }
        return(<button className="navbar navbar-info navigationBar spacing__container" onClick={this.exit}>
                    <div className="container">
                        <div className="pull-left"><h3>{navText}</h3></div>
                        <div className="pull-right"><a className="arrow"><i className={rightIcon}></i></a></div>
                    </div>
                </button>);
    }

    renderAsfButtonLink() {
        return (
            <div>
                <a
                  className="btn btn-download button-link"
                  id="asfCongratulationsPageButtonLink"
                  href={
                    window.NOA.configuration.firstNetDccUrl +
                    '&eOin=' + 
                    this.state.investorDetails.eOin +
                    '&eAccountNumber=' + 
                    this.state.investorDetails.eAccountNumber
                  }
                  >
                    Set up adviser <br/> service fee
                </a>
            </div>
        );
    }

    renderCompleteAccountApplication() {
        if (this.state.isShellAccount) {
          return (
            <div className="container">
              {this.state.asfCongratulationsPageSwitch.killSwitch ? (
                <h4>Complete account application</h4>
              ) : null}
            </div>
          );
        }
    }
}


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/Congratulations.jsx